import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF'
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons/faBriefcase'
import { faHandPointUp } from '@fortawesome/free-solid-svg-icons/faHandPointUp'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { faDesktopAlt } from '@fortawesome/pro-light-svg-icons/faDesktopAlt'
import { faHandshake } from '@fortawesome/pro-light-svg-icons/faHandshake'
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt'
import { faMedal } from '@fortawesome/pro-light-svg-icons/faMedal'
import { faMobileAndroid } from '@fortawesome/pro-light-svg-icons/faMobileAndroid'
import { faStar } from '@fortawesome/pro-light-svg-icons/faStar'
import { faThLarge } from '@fortawesome/pro-light-svg-icons/faThLarge'

import KUNUNU_LOGO_SEARCH from '../../../company_search/static/company_search/images/kununu_logo_black.svg'
import KUNUNU_LOGO_DETAIL from '../../../company_search/static/company_search/images/kununu_logo_sapphireblue.svg'
import STAR_EMPTY_IMAGE from '../../../company_search/static/company_search/images/star_empty.png'
import STAR_FULL_IMAGE from '../../../company_search/static/company_search/images/star_full.png'
import STAR_HALF_IMAGE from '../../../company_search/static/company_search/images/star_half.png'
import ERROR_IMAGE from '../../../data/global_static/images/page_not_found.svg'
import NAV_BRAND_LOGO from '../../../data/global_static/images/yf_logo.svg'
import HOMEPAGE_GUIDES_APPLICATION from '../../../portals/static/portals/yf_de/home/images/bewerben_leicht_gemacht.jpg'
import HOMEPAGE_GUIDES_HEALTH from '../../../portals/static/portals/yf_de/home/images/BGMApfel.jpg'
import HOMEPAGE_FOOTER_FACEBOOK from '../../../portals/static/portals/yf_de/home/images/facebook.png'
import HOMEPAGE_FOOTER_FACEBOOK_2X from '../../../portals/static/portals/yf_de/home/images/facebook@2x.png'
import HOMEPAGE_GUIDES_INTERVIEW from '../../../portals/static/portals/yf_de/home/images/firmen_im_interview.jpg'
import HOMEPAGE_GUIDES_SALARY from '../../../portals/static/portals/yf_de/home/images/geldklein.jpg'
import HOMEPAGE_FOOTER_INSTAGRAM from '../../../portals/static/portals/yf_de/home/images/instagram.png'
import HOMEPAGE_FOOTER_INSTAGRAM_2X from '../../../portals/static/portals/yf_de/home/images/instagram@2x.png'
import HOMEPAGE_GUIDES_JOBFAIR from '../../../portals/static/portals/yf_de/home/images/jobmessen.jpg'
import HOMEPAGE_GUIDES_CAREER from '../../../portals/static/portals/yf_de/home/images/karriere_im_mittelstand.jpg'
import HOMEPAGE_FOOTER_LINKEDIN from '../../../portals/static/portals/yf_de/home/images/linkedin.png'
import HOMEPAGE_FOOTER_LINKEDIN_2X from '../../../portals/static/portals/yf_de/home/images/linkedin@2x.png'
import HOMEPAGE_FOOTER_LOGO from '../../../portals/static/portals/yf_de/home/images/logo.svg'
import HOMEPAGE_GUIDES_SOCIAL from '../../../portals/static/portals/yf_de/home/images/shutterstock_2306838.jpg'
import HOMEPAGE_GUIDES_BRANDING from '../../../portals/static/portals/yf_de/home/images/shutterstock_54938614.jpg'
import HOMEPAGE_GUIDES_JOBWIKI from '../../../portals/static/portals/yf_de/home/images/shutterstock_57835027_1.jpg'
import HOMEPAGE_GUIDES_BURNOUT from '../../../portals/static/portals/yf_de/home/images/shutterstock_61943356.jpg'
import HOMEPAGE_GUIDES_SHORTAGE from '../../../portals/static/portals/yf_de/home/images/shutterstock_65342389.jpg'
import HOMEPAGE_GUIDES_ATTRACTIVENESS from '../../../portals/static/portals/yf_de/home/images/shutterstock_65723896.jpg'
import HOMEPAGE_FOOTER_TWITTER from '../../../portals/static/portals/yf_de/home/images/twitter.png'
import HOMEPAGE_FOOTER_TWITTER_2X from '../../../portals/static/portals/yf_de/home/images/twitter@2x.png'
import HOMEPAGE_STATIC_HEADER_IMAGE from '../../../portals/static/portals/yf_de/home/images/wljim3.png'
import HOMEPAGE_FOOTER_XING from '../../../portals/static/portals/yf_de/home/images/xing.png'
import HOMEPAGE_FOOTER_XING_2X from '../../../portals/static/portals/yf_de/home/images/xing@2x.png'
import HOMEPAGE_FOOTER_YOUTUBE from '../../../portals/static/portals/yf_de/home/images/youtube.png'
import HOMEPAGE_FOOTER_YOUTUBE_2X from '../../../portals/static/portals/yf_de/home/images/youtube@2x.png'

import { KUNUNU_WIDGET_DETAIL_TYPE, KUNUNU_WIDGET_LIST_TYPE } from './constants'

const CONFIG = global.CONFIG || {}

// Load icons for use in menu
library.add(faSearch, faBriefcase, faInfo, faHandPointUp, faFacebookF, faInstagram, faLinkedinIn)

/**
 * List of restrictions to lift from iframe sandbox model
 * @ref https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-sandbox
 * @ref https://html.spec.whatwg.org/multipage/origin.html#sandboxing
 * @type {string}
 */
export const IFRAME_SANDBOX = [
  // allow opening modals, e.g. print preview
  'allow-modals',
  // required so iframe resizer and link replacer can work
  'allow-scripts',
  // allow opening links in new tab target="blank"
  'allow-popups',
  // maybe bug, but is required for target="blank" to work
  'allow-top-navigation',
  // let the newly opened page be unrestricted
  'allow-popups-to-escape-sandbox',
  // disable any adware popup, will allow navigation only on user action
  'allow-top-navigation-by-user-activation',
  // allow form submission as we have external links that are opened inside the iframe
  // and point to application forms that should be usable
  'allow-forms',
  // some scripts require access to cookies or communication with backend
  // this preserves the origin of the iframe, and only presents risk if
  // the origin is the same as the hosting document.
  // features that require this:
  // * youtube
  // * vimeo
  // * recaptcha
  'allow-same-origin'
].join(' ')

// Integrations configuration
export const INTEGRATION = {
  gmap: {
    apiKey: process.env.GOOGLE_API_BROWSER_KEY
  },
  xing: {
    consumerKey: '619c1df3936f7b4157c4'
  },
  geocode: {
    apiKey: process.env.GOOGLE_API_GEOCODE_KEY
  },
  ...CONFIG.INTEGRATION
}

/**
 * Configure initial state source of truth - location or state
 * @deprecated - refactored state - location bridge and currently the state is always the primary source
 */
export const INITIAL_STATE = CONFIG.INITIAL_STATE || 'location'

/**
 * Configuration of filters
 */
export const FILTERS = CONFIG.FILTERS || [
  {
    id: 'Taetigkeitsbereich',
    label: 'Tätigkeit',
    items: [
      { id: 24, label: 'Rechtswesen' },
      { id: 34, label: 'Architektur, Bauwesen' }
    ]
  },
  {
    id: 'Vertragsart',
    label: 'Anstellungsart',
    items: [
      { id: 10, label: 'Festanstellung Vollzeit' },
      { id: 25, label: 'Ausbildung' },
      { id: 26, label: 'Festanstellung Teilzeit' }
    ]
  },
  {
    id: 'Branche',
    label: 'Branche',
    items: [
      { id: 39, label: 'Automobil- & Fahrzeugbau' },
      { id: 21, label: 'Bauindustrie' }
    ]
  }
]

/**
 * Various files locations
 */
export const FILES = {
  ERROR_IMAGE,
  STAR_EMPTY_IMAGE,
  STAR_HALF_IMAGE,
  STAR_FULL_IMAGE,
  KUNUNU_LOGO_SEARCH,
  KUNUNU_LOGO_DETAIL,
  ...(CONFIG.FILES || {})
}

/**
 * Main menu content. Used icons must be added to library at the top
 */
export const MAIN_MENU = CONFIG.MAIN_MENU || [
  {
    label: 'Jobs',
    icon: 'search',
    href: '/jobs/',
    state: { type: 'job' },
    title: 'Job suchen'
  },
  {
    label: 'Firmen',
    icon: 'briefcase',
    href: '/unternehmen/',
    state: { type: 'company' },
    title: 'Unternehmensbörse'
  },
  {
    label: 'Ratgeber',
    icon: 'info',
    href: '/karriere-ratgeber/',
    title: 'Karriere Ratgeber'
  },
  {
    label: 'Für Arbeitgeber',
    icon: 'hand-point-up',
    href: '/arbeitgeber/',
    title: 'Anzeige schalten'
  }
]

/**
 * Reported to GTM for analytics purposes, could be overriden by job.tracking with similar keys
 */
export const TRACKING = {
  jobPageVariation: 'portal',
  ...CONFIG.TRACKING
}

/**
 * Tracking configuration
 */
export const TRACKING_CONFIGURATION = {
  jobShareTrackingParams: {},
  companyShareTrackingParams: {},
  kununuTrackingParams: {
    utm_campaign: 'yourfirm',
    utm_source: 'custom_integration',
    utm_medium: 'Affiliates'
  },
  cmsArticleTrackingParams: {
    utm_campaign: 'yf_share_article',
    utm_medium: 'direct'
  },
  ...CONFIG.TRACKING_CONFIGURATION
}

/**
 * Configuration parameters for qualified view tracking
 */
export const QUALIFIED_VIEW = {
  /**
   * Interval in ms for the page to have been in focus, before it's considered a qualified view
   */
  focusDuration: 10000,
  /**
   * Percentage of job frame to have been scrolled, before it's considered a qualified view
   */
  scrollThreshold: 0.8,
  ...CONFIG.QUALIFIED_VIEW
}

export const COMPANY_JOBS = {
  /**
   * Number of items in a single page. Used to decide if another page exists or
   * end of results is reached
   */
  pageSize: 10,
  ...CONFIG.COMPANY_JOBS
}
export const SEARCH = {
  defaultLocation: '',
  distance: {
    values: [10, 20, 30, 40, 50, 75, 100],
    default: 50
  },
  types: {
    job: {
      enabled: true,
      paging: { limit: 20 },
      location: '/suche/all/'
    },
    company: {
      enabled: true,
      paging: { limit: 20 },
      location: '/arbeitgebersuche/'
    }
  },
  // obfuscate search results info if returned number of jobs/companies more than defined value
  exactResultCountLimit: 100,
  // these parameters are used for non-integrated search to be passed as additional query parameters
  // to from the search form.
  // TODO: maybe duplicates state.search.fixed + state.search.initial
  extraParams: {},
  // enable sort ordering for jobs
  jobSortingEnabled: true,
  ...CONFIG.SEARCH
}

export const NAV_BRAND = {
  portal_type: 'yf',
  portal_name: 'Yourfirm',
  logo: NAV_BRAND_LOGO,
  logo_mobile: NAV_BRAND_LOGO,
  title: 'YOURFIRM',
  subtitle: 'Wir lieben Jobs im Mittelstand',
  claim: '',
  is_linked: true,
  ...CONFIG.NAV_BRAND
}

export const APPLICATION = {
  acceptedFiles: {
    'image/*': ['.gif', '.jpg', '.jpeg', '.png', '.tif', '.tiff'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/application/vnd.oasis.opendocument.text': ['.odt'],
    'application/pdf': ['.pdf'],
    'application/application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
    'application/rtf': ['.rtf'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'text/plain': ['.txt', '.text']
  },
  preferMailto: false,
  maxJobsForApplication: 10,
  maxAttachmentCount: 15,
  maxAttachmentSize: 20 * 1024 * 1024,
  ...CONFIG.APPLICATION
}

export const SWITCHES = {
  // should click on search result open the result integrated or in new tab
  integratedDetails: false,
  // should search form submit or handle internally
  integratedSearch: true,
  // enables or disables auto select first search result mode.
  // selection is handled with 'search.showFirstResult' state
  showFirstResultMode: true,
  // activates showing of similar job on direct job pages
  similarJobs: true,
  // activates express application form
  enableExpressApplication: false,
  // activates jobmail component
  enableJobmail: true,
  ...CONFIG.SWITCHES
}

/**
 * Flag values for features and A/B tests
 */
export const FEATURE_FLAGS = {
  ...CONFIG.FEATURE_FLAGS
}

export const JOB_ADMIN_LINK_TEMPLATE = CONFIG.JOB_ADMIN_LINK_TEMPLATE || '/admin/stand/job/{id}/change/'

/**
 * Template for job-simple urls, available parameters:
 * @param id {number} - job id
 * @type {string}
 */
export const SIMPLE_JOB_URL = CONFIG.SIMPLE_JOB_URL || '/job-simple/{id}/'

/**
 * Height of landing page preview block for mobile devices, in px
 */
export const LANDING_PAGE_PREVIEW_HEIGHT = 90

/**
 * Homepage configuration
 */
export const HOMEPAGE = {
  yf: {
    /**
     * Configuration for the static header above search
     */
    staticHeader: {
      image: {
        src: HOMEPAGE_STATIC_HEADER_IMAGE,
        alt: 'Wir lieben Jobs im Mittelstand.'
      }
    },
    /**
     * Configuration for featured guides
     */
    guides: [
      {
        tab: 'Karriereratgeber',
        images: [
          {
            label: 'Karriere im Mittelstand',
            url: '/karriere-ratgeber/karriere-im-mittelstand/',
            img: HOMEPAGE_GUIDES_CAREER
          },
          {
            label: 'Firmen im Interview',
            url: '/karriere-ratgeber/firmenvorstellung/',
            img: HOMEPAGE_GUIDES_INTERVIEW
          },
          {
            label: 'Bewerben leicht gemacht',
            url: '/karriere-ratgeber/bewerbung/',
            img: HOMEPAGE_GUIDES_APPLICATION
          },
          {
            label: 'JobWiki',
            url: '/karriere-ratgeber/jobwiki/',
            img: HOMEPAGE_GUIDES_JOBWIKI
          },
          {
            label: 'Gehalt',
            url: '/karriere-ratgeber/gehalt/',
            img: HOMEPAGE_GUIDES_SALARY
          },
          {
            label: 'Jobmessen',
            url: '/karriere-ratgeber/jobmessen/',
            img: HOMEPAGE_GUIDES_JOBFAIR
          }
        ]
      },
      {
        tab: 'Recruitingratgeber',
        images: [
          {
            label: 'Employer Branding',
            url: '/recruiting-ratgeber/unternehmen-als-arbeitgeber/employer-branding/',
            img: HOMEPAGE_GUIDES_BRANDING
          },
          {
            label: 'Betriebliches Gesundheitsmanagement',
            url: '/recruiting-ratgeber/mitarbeiter-im-fokus/betriebliches-gesundheitsmanagement/',
            img: HOMEPAGE_GUIDES_HEALTH
          },
          {
            label: 'Burnout Prävention',
            url: '/recruiting-ratgeber/mitarbeiter-im-fokus/burnout-praevention/',
            img: HOMEPAGE_GUIDES_BURNOUT
          },
          {
            label: 'Social Media: Bewerbererwartungen',
            url: '/recruiting-ratgeber/recruiting-tipps/social-recruiting/social-recruiting-expertentipps/',
            img: HOMEPAGE_GUIDES_SOCIAL
          },
          {
            label: 'Arbeitgeberattraktivität',
            url: '/recruiting-ratgeber/unternehmen-als-arbeitgeber/arbeitgeberattraktivitaet/',
            img: HOMEPAGE_GUIDES_ATTRACTIVENESS
          },
          {
            label: 'Fachkräftemangel',
            url: '/recruiting-ratgeber/recruiting-tipps/fachkraeftemangel/',
            img: HOMEPAGE_GUIDES_SHORTAGE
          }
        ]
      }
    ],
    /**
     *
     */
    companyGroups: [
      {
        tab: 'Arbeitgeber nach Orten',
        suggestions: [
          { label: 'München', href: '/unternehmen/muenchen/' },
          { label: 'Stuttgart', href: '/unternehmen/stuttgart/' },
          { label: 'Köln', href: '/unternehmen/koeln/' },
          { label: 'Frankfurt am Main', href: '/unternehmen/frankfurt-am-main/' },
          { label: 'Mainz', href: '/unternehmen/mainz/' },
          { label: 'Dortmund', href: '/unternehmen/dortmund/' },
          { label: 'Hamburg', href: '/unternehmen/hamburg/' },
          { label: 'Berlin', href: '/unternehmen/berlin/' },
          { label: 'Mannheim', href: '/unternehmen/mannheim/' },
          { label: 'Karlsruhe', href: '/unternehmen/karlsruhe/' },
          { label: 'Nürnberg', href: '/unternehmen/nuernberg/' },
          { label: 'Hannover', href: '/unternehmen/hannover/' },
          { label: 'Dresden', href: '/unternehmen/dresden/' },
          { label: 'Leipzig', href: '/unternehmen/leipzig/' },
          { label: 'Bremen', href: '/unternehmen/bremen/' },
          { label: 'Erfurt', href: '/unternehmen/erfurt/' },
          { label: 'Rostock', href: '/unternehmen/rostock/' },
          { label: 'Kiel', href: '/unternehmen/kiel/' }
        ]
      },
      {
        tab: 'Arbeitgeber nach Branchen',
        suggestions: [
          {
            label: 'Maschinen- und Anlagenbau',
            href: '/maschinenbauunternehmen/'
          },
          {
            label: 'Elektronik, High-Tech & Optik',
            href: '/elektrotechnik-unternehmen/'
          },
          {
            label: 'Dienstleistungen',
            href: '/dienstleistungsunternehmen/'
          },
          {
            label: 'IT, Internet & Telekom',
            href: '/it-unternehmen/'
          },
          {
            label: 'Konsum- & Gebrauchsgüter',
            href: '/konsumgueter-unternehmen/'
          },
          {
            label: 'Automobil- & Fahrzeugbau',
            href: '/fahrzeugbau-unternehmen/'
          },
          {
            label: 'Bauindustrie',
            href: '/bauunternehmen/'
          },
          {
            label: 'Chemie, Pharma & Medizin',
            href: '/chemieunternehmen/'
          },
          {
            label: 'Bergbau, Rohstoffe & Material',
            href: '/rohstoff-unternehmen/'
          },
          {
            label: 'Handel',
            href: '/handelsunternehmen/'
          },
          {
            label: 'Energie, Versorgung & Umwelt',
            href: '/energie-unternehmen/'
          },
          {
            label: 'Logistik, Transport & Verkehr',
            href: '/logistikunternehmen/'
          },
          {
            label: 'Druck, Papier & Verpackungen',
            href: '/papier-unternehmen/'
          },
          {
            label: 'Unternehmensberatung',
            href: '/unternehmensberatung-unternehmen/'
          },
          {
            label: 'Werkzeugbau',
            href: '/werkzeugbau-unternehmen/'
          },
          {
            label: 'Luft- Raum- & Schifffahrt',
            href: '/luftfahrt-unternehmen/'
          },
          {
            label: 'Finanzdienstleistung',
            href: '/finanzunternehmen/'
          },
          {
            label: 'Wirtschaftsprüfung, Recht & Steuern',
            href: '/wirtschaftspruefung-unternehmen/'
          }
        ]
      }
    ],
    // test data - needs to be provided by backend
    topCompanies: process.env.NODE_ENV !== 'production'
      ? [
          {
            name: 'Liftstar GmbH',
            cover: {
              '380w': 'http://via.placeholder.com/380x380',
              '760w': 'http://via.placeholder.com/760x760',
              '1240w': 'http://via.placeholder.com/1240x1240'
            },
            logo: 'http://via.placeholder.com/100x100',
            url: '/firmenprofile/Liftstar-Holding---10343/'
          },
          {
            name: 'Stadler + Schaaf Mess- und Regeltechnik  GmbH',
            cover: 'http://via.placeholder.com/380x380',
            logo: 'http://via.placeholder.com/100x45',
            url: '/firmenprofile/stadlerschaaf---19168/'
          },
          {
            name: 'Paychex Deutschland GmbH',
            cover: {
              '1x': 'http://via.placeholder.com/380x380',
              '2x': 'http://via.placeholder.com/760x760'
            },
            logo: 'http://via.placeholder.com/100x45',
            url: '/firmenprofile/paychex---4055/'
          }
        ]
      : null,
    topCompaniesLabel: 'Top Arbeitgeber',
    /**
     * Configuration for buttons in employer section
     */
    employerContacts: {
      phone: '089-4161411-690',
      email: 'anfrage@yourfirm.de',
      brochureUrl: 'https://upload.wikimedia.org/wikipedia/commons/d/d3/Test.pdf'
    },
    /**
     * Configuration for the static footer
     */
    staticFooterImages: {
      logo: {
        src: HOMEPAGE_FOOTER_LOGO,
        alt: 'Yourfirm'
      },
      social: [
        {
          src: HOMEPAGE_FOOTER_FACEBOOK,
          srcSet: `${HOMEPAGE_FOOTER_FACEBOOK} 1x, ${HOMEPAGE_FOOTER_FACEBOOK_2X} 2x`,
          alt: 'Facebook',
          href: 'https://www.facebook.com/YOURFIRM'
        },
        {
          src: HOMEPAGE_FOOTER_TWITTER,
          srcSet: `${HOMEPAGE_FOOTER_TWITTER} 1x, ${HOMEPAGE_FOOTER_TWITTER_2X} 2x`,
          alt: 'Twitter',
          href: 'https://twitter.com/yourfirm_de'
        },
        {
          src: HOMEPAGE_FOOTER_INSTAGRAM,
          srcSet: `${HOMEPAGE_FOOTER_INSTAGRAM} 1x, ${HOMEPAGE_FOOTER_INSTAGRAM_2X} 2x`,
          alt: 'Instagram',
          href: 'https://www.instagram.com/yourfirm/'
        },
        {
          src: HOMEPAGE_FOOTER_YOUTUBE,
          srcSet: `${HOMEPAGE_FOOTER_YOUTUBE} 1x, ${HOMEPAGE_FOOTER_YOUTUBE_2X} 2x`,
          alt: 'Youtube',
          href: 'https://www.youtube.com/channel/UCID9XkO3NnLHnNQkgDx71UA'
        },
        {
          src: HOMEPAGE_FOOTER_XING,
          srcSet: `${HOMEPAGE_FOOTER_XING} 1x, ${HOMEPAGE_FOOTER_XING_2X} 2x`,
          alt: 'Xing',
          href: 'https://www.xing.com/pages/yourfirmgmbh'
        },
        {
          src: HOMEPAGE_FOOTER_LINKEDIN,
          srcSet: `${HOMEPAGE_FOOTER_LINKEDIN} 1x, ${HOMEPAGE_FOOTER_LINKEDIN_2X} 2x`,
          alt: 'LinkedIn',
          href: 'https://de.linkedin.com/company/yourfirm'
        }
      ]
    },
    staticFooterLinks: {
      aboutLinks: [
        { label: 'Stellenanzeige aufgeben', href: '/recruiting/' },
        { label: 'Referenzen', href: '/referenzen/' },
        { label: 'Pressebereich', href: '/presse/' },
        { label: 'Über uns', href: '/ueber-yourfirm/' },
        { label: 'Team', href: '/team/' },
        { label: 'Karriere bei Yourfirm', href: '/firmenprofile/yourfirm/' }
      ],
      infoLinks: [
        { label: 'Kontakt', href: '/kontakt/' },
        { label: 'Nutzungsbedingungen', href: '/nutzungsbedingungen/' },
        { label: 'Datenschutz', href: '/datenschutz/' },
        { label: 'AGB', href: '/agb/' },
        { label: 'Impressum', href: '/impressum/' }
      ]
    },
    ...CONFIG.HOMEPAGE?.yf
  },
  rja: {
    // test data - needs to be provided by backend
    topCompanies: process.env.NODE_ENV !== 'production'
      ? [
          {
            name: 'Liftstar GmbH',
            cover: {
              '380w': 'http://via.placeholder.com/380x380',
              '760w': 'http://via.placeholder.com/760x760',
              '1240w': 'http://via.placeholder.com/1240x1240'
            },
            logo: 'http://via.placeholder.com/100x100',
            url: '/firmenprofile/Liftstar-Holding---10343/'
          },
          {
            name: 'Stadler + Schaaf Mess- und Regeltechnik  GmbH',
            cover: 'http://via.placeholder.com/380x380',
            logo: 'http://via.placeholder.com/100x45',
            url: '/firmenprofile/stadlerschaaf---19168/'
          },
          {
            name: 'Paychex Deutschland GmbH',
            cover: {
              '1x': 'http://via.placeholder.com/380x380',
              '2x': 'http://via.placeholder.com/760x760'
            },
            logo: 'http://via.placeholder.com/100x45',
            url: '/firmenprofile/paychex---4055/'
          }
        ]
      : null,
    staticFooterImages: {
      social: [
        {
          icon: 'facebook-f',
          href: 'https://www.facebook.com/regiojobanzeiger/'
        }, {
          icon: 'linkedin-in',
          href: 'https://www.linkedin.com/company/regio-jobanzeiger-gmbh-&-co--kg/'
        }, {
          icon: 'instagram',
          href: 'https://www.instagram.com/regiojobanzeiger/'
        }
      ]
    },
    // test data - needs to be provided by backend
    about: process.env.NODE_ENV !== 'production'
      ? {
          image: 'http://via.placeholder.com/600x600',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ' +
            'ut labore et dolore magna aliqua. Eget dolor morbi non arcu risus quis varius. Posuere lorem ' +
            'ipsum dolor sit amet consectetur adipiscing elit duis. Enim eu turpis egestas pretium aenean ' +
            'pharetra magna ac. Commodo nulla facilisi nullam vehicula. Velit aliquet sagittis id ' +
            'consectetur purus ut faucibus. Velit dignissim sodales ut eu sem integer vitae justo. ' +
            'Nisl condimentum id venenatis a. Risus quis varius quam quisque. Nibh tortor id aliquet ' +
            'lectus. Scelerisque purus semper eget duis at.',
          url: '/agb/',
          portalLocation: 'Portal'
        }
      : null,
    /**
     * Configuration for RJA advantages block
     */
    advantages: {
      stats:
        [
          {
            icon: faStar,
            number: '1.000',
            title: 'Mögliche regionale Aufrufe pro Stellenanzeige'
          },
          {
            icon: faMobileAndroid,
            number: '16.000',
            title: 'Apps'
          },
          {
            icon: faDesktopAlt,
            number: '16.000',
            title: 'Partner Websites'
          },
          {
            icon: faThLarge,
            number: '150',
            title: 'Partner Jobbörsen'
          }
        ],
      benefits:
        [
          {
            icon: faMapMarkerAlt,
            title: '1 Partner – 91 regionale Jobportale',
            text: 'Unsere einzigartige Regio-Online-Marketing (ROM)-Technologie basiert auf mehr als 25 Jahren Expertise im Jobbörsen-Markt und komplettiert Regio-Jobanzeiger zur optimalen Lösung für Stellenanzeigen. Egal ob Sie in Oberbayern, Erfurt oder Bremerhaven Bewerber suchen, wir haben die passenden regionalen Stellenmärkte und Vermarktungskanäle für alle Stellenanzeigen.'
          },
          {
            icon: faMedal,
            title: 'Alle Fachrichtungen & Qualifikationen',
            text: 'Ob Aushilfe, Fachpersonal oder Führungskraft für die Filiale, Niederlassung oder Zentrale: Bewerber suchen regional. Durch die Schaltung Ihrer Stellenanzeigen über Regio-Jobanzeiger erreichen Sie immer kostengünstig und effektiv gezielt Kandidaten „von hier“'
          },
          {
            icon: faHandshake,
            title: 'Schneller und zuverlässiger Service',
            text: 'Sie buchen, wir realisieren: Ihre Stellenanzeigen werden von Ihrem persönlichen Ansprechpartner digital umgesetzt. Sie erhalten ein automatisches Reporting der Performance Ihrer Stellenanzeigen.'
          }
        ]
    },
    sealImages: [
      'http://via.placeholder.com/140x120',
      'http://via.placeholder.com/102x120',
      'http://via.placeholder.com/102x120'
    ],
    ...CONFIG.HOMEPAGE?.rja
  }
}

/**
 * wait time to load and show content in ms
 */
export const CONTENT_LOAD_WAIT_TIME = CONFIG.CONTENT_LOAD_WAIT_TIME || 1000

export const SENTRY = { ...CONFIG.SENTRY }

export const CHAR_LOGO_BG_COLORS = CONFIG.CHAR_LOGO_BG_COLORS || []

export const COMPANY_PROFILE = {
  HIDDEN_COUNTRY_CODES: ['DE', 'AT'],
  MAP_VISIBLE_COUNTRIES: ['DE', 'AT']
}

export const CMS = {
  YFSOCIAL: {
    facebook: 'https://facebook.com/YOURFIRM',
    twitter: 'yourfirm_de'
  },
  SEARCH_RESULTS_MAX_JOBS: 2
}

/**
 * MESSAGES that backend needs to show to user. For example jobmail deactivation
 * Format { text: string, type: enum('alert', 'success', 'error', 'warning', 'info')}
 */
export const MESSAGES = global.MESSAGES || []

/**
 * Used for runtime configuration of hydra static files from backend in publicPath.
 * Declared here for configuration completeness, should not be used directly.
 */
// export const HYDRA_STATIC_PREFIX = CONFIG.HYDRA_STATIC_PREFIX

/**
 * Delay in ms for loading of lazy containers to give chance
 * for main page rendering.
 * @type {number}
 */
// Currently 3.5s is the average time to render page, but most of that time
// is in the loading so when containers are requested to load html and js bundle
// are loaded
export const LAZY_CONTAINER_LOAD_DELAY = 1000

// Hydra auth config
export const AUTH = {
  // Enables or disables hydra auth functionalities
  enabled: true,
  ...CONFIG.AUTH
}

/**
 * Map of jobs categories to list of job search links - displayed in SuggestedJobSearches
 */
export const JOB_SEARCH_SUGGESTIONS = [
  {
    label: 'Jobs nach Tätigkeiten',
    suggestions: [
      {
        href: '/jobangebote/bank/',
        label: 'Banken'
      },
      {
        href: '/jobangebote/marketing/',
        label: 'Marketing'
      },
      {
        href: '/jobangebote/it/',
        label: 'IT'
      },
      {
        href: '/jobangebote/logistik/',
        label: 'Logistik'
      },
      {
        href: '/jobangebote/vertrieb/',
        label: 'Vertrieb'
      },
      {
        href: '/jobangebote/ingenieur/',
        label: 'Ingenieur'
      },
      {
        href: '/jobangebote/oeffentlicher-dienst/',
        label: 'Öffentlicher Dienst'
      },
      {
        href: '/jobangebote/lager/',
        label: 'Lager'
      },
      {
        href: '/jobangebote/buero/',
        label: 'Büro'
      },
      {
        href: '/jobangebote/gastronomie/',
        label: 'Gastronomie'
      },
      {
        href: '/jobangebote/medien/',
        label: 'Medien'
      },
      {
        href: '/jobangebote/consulting/',
        label: 'Consulting'
      },
      {
        href: '/jobangebote/management/',
        label: 'Management'
      },
      {
        href: '/jobangebote/personal/',
        label: 'Personal'
      },
      {
        href: '/jobangebote/handwerk/',
        label: 'Handwerk'
      },
      {
        href: '/jobangebote/maschinenbau/',
        label: 'Maschinenbau'
      },
      {
        href: '/jobangebote/finanzen/',
        label: 'Finanzen'
      },
      {
        href: '/jobangebote/bau/',
        label: 'Bau'
      },
      {
        href: '/jobangebote/medizin/',
        label: 'Medizin'
      },
      {
        href: '/jobangebote/bildung/',
        label: 'Bildung'
      },
      {
        href: '/jobangebote/controlling/',
        label: 'Controlling'
      },
      {
        href: '/jobangebote/produktion/',
        label: 'Produktion'
      },
      {
        href: '/jobangebote/sozialpaedagogik/',
        label: 'Sozialpädagogik'
      },
      {
        href: '/jobangebote/sap/',
        label: 'SAP'
      },
      {
        href: '/jobangebote/medizintechnik/',
        label: 'Medizintechnik'
      }
    ]
  },
  {
    label: 'Jobs nach Orten',
    suggestions: [
      {
        href: '/stellenangebote/home-office/',
        label: 'Homeoffice'
      },
      {
        href: '/stellenangebote/berlin/',
        label: 'Berlin'
      },
      {
        href: '/stellenangebote/hamburg/',
        label: 'Hamburg'
      },
      {
        href: '/stellenangebote/muenchen/',
        label: 'München'
      },
      {
        href: '/stellenangebote/leipzig/',
        label: 'Leipzig'
      },
      {
        href: '/stellenangebote/koeln/',
        label: 'Köln'
      },
      {
        href: '/stellenangebote/hannover/',
        label: 'Hannover'
      },
      {
        href: '/stellenangebote/bremen/',
        label: 'Bremen'
      },
      {
        href: '/stellenangebote/nuernberg/',
        label: 'Nürnberg'
      },
      {
        href: '/stellenangebote/dresden/',
        label: 'Dresden'
      },
      {
        href: '/stellenangebote/stuttgart/',
        label: 'Stuttgart'
      },
      {
        href: '/stellenangebote/augsburg/',
        label: 'Augsburg'
      },
      {
        href: '/stellenangebote/frankfurt-am-main/',
        label: 'Frankfurt am Main'
      },
      {
        href: '/stellenangebote/ulm/',
        label: 'Ulm'
      },
      {
        href: '/stellenangebote/regensburg/',
        label: 'Regensburg'
      },
      {
        href: '/stellenangebote/duesseldorf/',
        label: 'Düsseldorf'
      },
      {
        href: '/stellenangebote/rostock/',
        label: 'Rostock'
      },
      {
        href: '/stellenangebote/dortmund/',
        label: 'Dortmund'
      },
      {
        href: '/stellenangebote/wuerzburg/',
        label: 'Würzburg'
      },
      {
        href: '/stellenangebote/kiel/',
        label: 'Kiel'
      },
      {
        href: '/stellenangebote/kassel/',
        label: 'Kassel'
      },
      {
        href: '/stellenangebote/luebeck/',
        label: 'Lübeck'
      },
      {
        href: '/stellenangebote/mannheim/',
        label: 'Mannheim'
      },
      {
        href: '/stellenangebote/bielefeld/',
        label: 'Bielefeld'
      },
      {
        href: '/stellenangebote/osnabrueck/',
        label: 'Osnabrück'
      }
    ]
  },
  {
    label: 'Beliebte Suchen',
    suggestions: [
      {
        href: '/jobangebote/verkaeufer/',
        label: 'Verkäufer'
      },
      {
        href: '/jobangebote/erzieher/',
        label: 'Erzieher'
      },
      {
        href: '/jobangebote/fahrer/',
        label: 'Fahrer'
      },
      {
        href: '/jobangebote/vertriebsinnendienst/',
        label: 'Vertriebsinnendienst'
      },
      {
        href: '/jobangebote/maschinenbautechniker/',
        label: 'Maschinenbautechniker'
      },
      {
        href: '/jobangebote/hausmeister/',
        label: 'Hausmeister'
      },
      {
        href: '/jobangebote/servicetechniker/',
        label: 'Servicetechniker'
      },
      {
        href: '/jobangebote/industriemechaniker/',
        label: 'Industriemechaniker'
      },
      {
        href: '/jobangebote/mediengestalter/',
        label: 'Mediengestalter'
      },
      {
        href: '/jobangebote/elektriker/',
        label: 'Elektriker'
      },
      {
        href: '/jobangebote/reinigungskraft/',
        label: 'Reinigungskraft'
      },
      {
        href: '/jobangebote/buerokauffrau/',
        label: 'Bürokauffrau'
      },
      {
        href: '/jobangebote/techniker/',
        label: 'Techniker'
      },
      {
        href: '/jobangebote/staplerfahrer/',
        label: 'Staplerfahrer'
      },
      {
        href: '/jobangebote/zerspanungsmechaniker/',
        label: 'Zerspanungsmechaniker'
      },
      {
        href: '/jobangebote/call-center/',
        label: 'Call Center'
      },
      {
        href: '/jobangebote/servicekraft/',
        label: 'Servicekraft'
      },
      {
        href: '/jobangebote/sachbearbeitung/',
        label: 'Sachbearbeitung'
      },
      {
        href: '/jobangebote/produktionshelfer/',
        label: 'Produktionshelfer'
      },
      {
        href: '/jobangebote/pflegefachkraft/',
        label: 'Pflegefachkraft'
      },
      {
        href: '/jobangebote/key-account-manager/',
        label: 'Key Account Manager'
      },
      {
        href: '/jobangebote/kaufmann/',
        label: 'Kaufmann'
      },
      {
        href: '/jobangebote/buchhalter/',
        label: 'Buchhalter'
      },
      {
        href: '/jobangebote/sozialarbeiter/',
        label: 'Sozialarbeiter'
      },
      {
        href: '/jobangebote/quereinsteiger/',
        label: 'Quereinsteiger'
      }
    ]
  }
]

export const RATING_WIDGET = {
  enabled: false,
  ...CONFIG.RATING_WIDGET
}

export const KUNUNU_WIDGET = {
  [KUNUNU_WIDGET_LIST_TYPE]: {
    star: {
      width: 10,
      height: 10
    }
  },
  [KUNUNU_WIDGET_DETAIL_TYPE]: {
    star: {
      width: 31,
      height: 27
    }
  }
}

export const TRACKING_GLOBALS = global.trackingGlobals = {}
